import { MapPin, Phone, Mail, ExternalLink } from "lucide-react";
import { CONTACT, LINKS, SOCIALS } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const Contact = () => (
    <section
        id="kontak"
        data-testid="kontak-section"
        aria-labelledby="kontak-title"
        className="bg-bh-offwhite py-24 sm:py-32 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={CONTACT.eyebrow}
                title={CONTACT.title}
                testid="kontak-title"
            />
            <div className="px-6 sm:px-8 grid lg:grid-cols-2 gap-10 items-stretch">
                <Reveal>
                    <div className="h-full bg-white rounded-3xl border border-bh-green/12 p-8 sm:p-10 shadow-[0_14px_40px_rgba(16,134,108,0.06)] flex flex-col">
                        <ul className="space-y-7 flex-1">
                            <li className="flex gap-4">
                                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-bh-light shrink-0">
                                    <MapPin className="w-5 h-5 text-bh-green" aria-hidden="true" />
                                </span>
                                <div>
                                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bh-gold mb-1.5">
                                        Alamat
                                    </p>
                                    <p data-testid="kontak-alamat" className="text-base leading-relaxed text-bh-ink/90">
                                        {CONTACT.address}
                                    </p>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-bh-light shrink-0">
                                    <Phone className="w-5 h-5 text-bh-green" aria-hidden="true" />
                                </span>
                                <div>
                                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bh-gold mb-1.5">
                                        WhatsApp
                                    </p>
                                    <a
                                        href={LINKS.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="kontak-whatsapp"
                                        className="text-base font-semibold text-bh-deep hover:text-bh-green"
                                    >
                                        {LINKS.whatsappDisplay}
                                    </a>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-bh-light shrink-0">
                                    <Mail className="w-5 h-5 text-bh-green" aria-hidden="true" />
                                </span>
                                <div>
                                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bh-gold mb-1.5">
                                        Email
                                    </p>
                                    <a
                                        href={`mailto:${LINKS.email}`}
                                        data-testid="kontak-email"
                                        className="text-base font-semibold text-bh-deep hover:text-bh-green break-all"
                                    >
                                        {LINKS.email}
                                    </a>
                                </div>
                            </li>
                        </ul>
                        <div className="mt-10 pt-8 border-t border-bh-green/10">
                            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bh-gold mb-4">
                                Media Sosial
                            </p>
                            <ul className="flex flex-wrap gap-3">
                                {SOCIALS.map((social) => (
                                    <li key={social.label}>
                                        <a
                                            href={social.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-testid={`social-link-${social.label.toLowerCase()}`}
                                            aria-label={`${social.label} PPTQ Baitul Haq`}
                                            className="inline-flex items-center gap-2 rounded-full border border-bh-green/20 px-4 py-2.5 text-xs font-bold uppercase tracking-[0.1em] text-bh-dark transition-colors duration-200 hover:border-bh-gold hover:text-bh-green"
                                        >
                                            <social.icon className="w-4 h-4" aria-hidden="true" />
                                            {social.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.14}>
                    <div className="h-full min-h-[380px] rounded-3xl overflow-hidden border border-bh-green/12 shadow-[0_14px_40px_rgba(16,134,108,0.06)] relative bg-bh-light">
                        <iframe
                            data-testid="kontak-map-iframe"
                            title="Peta lokasi PPTQ Baitul Haq, Gandusari, Trenggalek"
                            src={LINKS.mapsEmbed}
                            className="absolute inset-0 w-full h-full border-0"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                        <a
                            href={LINKS.maps}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="kontak-maps-link"
                            className="absolute bottom-4 right-4 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-xs font-bold uppercase tracking-[0.1em] text-bh-deep shadow-lg hover:text-bh-green"
                        >
                            Buka di Google Maps
                            <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
